<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet, isPlatform, toastController } from '@ionic/vue';
import { onBeforeMount, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { v4 as uuidv4 } from 'uuid';
import StorageService from './utils/StorageService'
import { SplashScreen } from '@capacitor/splash-screen'
// import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app'
import { Network } from '@capacitor/network'
import { usePushNotification } from '@/composables/usePushNotification';
import { useBadge } from './composables/useBadge';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import logo from '@/assets/logo.svg';


const router = useRouter();
const { set, get, increase, decrease } = useBadge();
const {
  token,
  getDeliveredNotifications,
  removeAllListeners,
  registerNotifications,
  getToken,
  sendNotificationToken,
  deleteToken
} = usePushNotification()

// network監視
Network.addListener('networkStatusChange', async (status) => {
  console.log('Network status changed', status);
  switch (status.connected) {
    case true:
       console.log('ネットワーク接続されています', status.connectionType);
      //  presentToast(`ネットワーク接続されました。${status.connectionType}`);
      break;
    case false:
      presentToast(`ネットワーク接続されていません。\nこのアプリをご使用になるにはネットワークに接続してください。`);
      break;
  }
});
const logCurrentNetworkStatus = async () => {
  const status = await Network.getStatus();
  console.log('Network status:', status);
};


onBeforeMount(async () => {
  const deviceUuid = await StorageService.get('deviceUuid')
  if (!deviceUuid) {
    await StorageService.set('deviceUuid', uuidv4())
  }
})

onMounted(async () => {
  SplashScreen.show()
  // const current = await CapacitorUpdater.current()
  // const builtin = (await CapacitorUpdater.getBuiltinVersion()).version
  // await presentToast(`appUpdater current: ${current.bundle.version} / builtin: ${builtin} / native: ${current.native}`, 'top', 4000)

  await logCurrentNetworkStatus();
})

async function checkRegistration() : Promise<boolean>{
  const user = await StorageService.get('user')
  console.log('User',JSON.stringify(user));
  return (user || user.is_registered) ? true : false
}

async function addTokenReceivedListner() {
  await FirebaseMessaging.addListener('tokenReceived', async event => {
    token.value = event.token;
    // alert('tokenReceived: ' + JSON.stringify(event))
    console.log('tokenReceived', event.token);
    if (await checkRegistration()) {
      try {
        const res = await sendNotificationToken(event.token)
      } catch (err) {
        console.error(err);
      }
    }else {
      console.log('未登録のため、デバイストークン送信は行いません');
    }
  });
}

async function addNotificationActionPerformedListener() {
  await FirebaseMessaging.addListener('notificationActionPerformed', async (event) => {
    console.log('notificationActionPerformed', { event });

    // badgeを減らす
    // Todo: バックエンド側で未読既読管理する必要ありそう
    await decrease();

    const data: any = event.notification.data;
    console.log('Action performed: ' + JSON.stringify(event.notification));
    // ルートパスがある場合は、ルートパスに遷移する
    if (data.route_path) {
      await router.push(data.route_path);
    }

  });
}
async function addNotificationReceivedListener() {
  await FirebaseMessaging.addListener('notificationReceived', async (event) => {
    console.log('notificationReceived',  JSON.stringify(event) );

    const title = event.notification.title;
    const body = event.notification.body;
    const { silent, badge } = event.notification.data as any;

    if (title && body) { console.log(`${title}\n${body}`)}
    // notification.data.silent が true の場合は、silent push通知として扱う
    if (silent === 'true') {
      alert('silent push通知: ' + JSON.stringify(event))
      console.log('silent push通知', JSON.stringify(event))
    }

    //badge制御
    const count = parseInt(badge, 10);
    if (count) {
      await set(count);
    }else {
      await increase();
    }
    console.log('Badge count', await get())

    // フォアグラウンドで受信の場合
    // Androidの場合、フォアグラウンドで受信した場合は通知が表示されないので、ここで処理する
    if(isPlatform('android')){
      // toastか local notificationで通知する
      // event.notification.data.route_path に遷移する

      // toast版表示 Todo: local notificationに変更
      await presentToast(`${title}：　${body}`, 'top', 10000, async () => {
        const data: any = event.notification.data;
        if (data.route_path) {
          await router.push(data.route_path);
          await decrease();
        }
      });
    }

  });
}

async function presentToast(
  message: string, position: 'top' | 'middle' | 'bottom' = 'top',
  duration = 3000,
  cb?: Function
): Promise<HTMLIonToastElement> {
  const toast = await toastController.create({
    header: cb ? '通知' : undefined,
    icon: cb ? logo : undefined,
    cssClass: 'notify-toast',
    message: message,
    duration: duration,
    position: position || 'top',
    swipeGesture: 'vertical',
    color: cb ? 'light'  : undefined,
    buttons: typeof cb === 'function' ? [
      {
        text: '表示',
        role: 'display',
        handler: () => {
          console.log('表示 clicked');
          cb();
        }
      }
    ] : []
  });
  await toast.present();
  return toast;
}


</script>


<style lang="scss">
ion-toast {
  &.notify-toast {
    --background: #f4f4fa;
    --box-shadow: 3px 3px 10px 0 rgba(0, 0, 0, 0.2);
    --color: #4b4a50;

    &::part(button) {
      border-left: 1px solid #d2d2d2;
      color: #030207;
      font-size: 15px;
    }
  }

}</style>
